import { defineComponent as r, resolveComponent as t, openBlock as n, createBlock as s, normalizeClass as i } from "vue";
import a from "../VIcon/VIcon.js";
import { _ as c } from "../../../_plugin-vue_export-helper-dad06003.js";
const p = r({
  name: "VArrow",
  components: { VIcon: a },
  props: {
    direction: {
      type: String,
      default: "left"
    },
    size: {
      type: Number,
      default: 10
    }
  }
});
function m(o, l, f, d, u, w) {
  const e = t("VIcon");
  return n(), s(e, {
    symbol: "arrow-left",
    size: o.size,
    class: i([
      "hobi-arrow tw-transform",
      o.direction === "down" ? "tw--rotate-90" : o.direction === "up" ? "tw-rotate-90" : o.direction === "right" ? "tw-rotate-180" : ""
    ])
  }, null, 8, ["size", "class"]);
}
const $ = /* @__PURE__ */ c(p, [["render", m]]);
export {
  $ as default
};
